import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

const Spinner = ({ color, size }) => (
  <span className={styles.spinner}>
    <span
      className={`${styles.graphic} ${color}`}
      style={{
        width: `${size}px`,
        height: `${size}px`
      }}
    />
  </span>
);

Spinner.propTypes = {
  color: PropTypes.oneOf(['default', 'white']),
  size: PropTypes.number
};

Spinner.defaultProps = {
  color: 'default',
  size: 20
};

export default Spinner;
